import { render, staticRenderFns } from "./addDivision.vue?vue&type=template&id=15fc41cb&scoped=true&"
import script from "./addDivision.vue?vue&type=script&lang=js&"
export * from "./addDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc41cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fc41cb')) {
      api.createRecord('15fc41cb', component.options)
    } else {
      api.reload('15fc41cb', component.options)
    }
    module.hot.accept("./addDivision.vue?vue&type=template&id=15fc41cb&scoped=true&", function () {
      api.rerender('15fc41cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serverManage/serverList/component/addDivision.vue"
export default component.exports